import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { CourseProvider } from 'presentation/hooks/courses';

import { Home } from 'presentation/pages/home/index';
import { Lesson } from 'presentation/pages/lesson';
import { RouteProvider } from 'presentation/routes/RouteProvider';

import { environment } from 'utils/environment.utils';
import { useAppcues } from 'presentation/hooks/appcues';

export const Routes = (): JSX.Element => {
    useAppcues();

    return (
        <Switch>
            <Route path="/version" component={() => <span>{environment.APP_VERSION}</span>} />
            <RouteProvider path="/:idOrSlug" exact component={Home} providerComponent={CourseProvider} />
            <RouteProvider
                path="/:idOrSlug/:moduleId/:lessonId"
                exact
                component={Lesson}
                providerComponent={CourseProvider}
            />
            <Redirect from="*" to="/" />
        </Switch>
    );
};
